import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "checkout",
  useLayout: true,
  children: [
    { id: SectionsKey.Checkout, order: 1 },
    // { id: SectionsKey.BenefitsSection, order: 2, identifier: Identifiers.BenefitsSection },
    // { id: SectionsKey.FollowUs, order: 3, identifier: Identifiers.FollowUs }
  ],
};

export default PageStruct;
